import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "@emotion/styled";
import Select from "react-select";
import { productSuggestionsOperations } from "state/ducks/store/productSuggestions";

const ProductPicker = ({ onSelect }) => {
  const dispatch = useDispatch();
  const establishment = useSelector((state) => state.session.establishment);
  const { products, isLoadingProducts } = useSelector((state) => state.store.productSuggestions);

  useEffect(() => {
    if (establishment) {
      dispatch(productSuggestionsOperations.listProductsForSuggestions(establishment));
    }
  }, [dispatch, establishment]);

  // Tri sur le libellé RÉELLEMENT affiché (nom + format) : l'API trie sur le nom
  // du produit générique, ce qui laissait des déclinaisons dans le désordre.
  const options = (products || [])
    .map((p) => ({
      value: p.id,
      label: p.name,
      categoryName: p.categoryName,
      suggestionCount: p.suggestionCount,
    }))
    .sort((a, b) =>
      a.label.localeCompare(b.label, "fr", { numeric: true, sensitivity: "base" })
    );

  const formatOptionLabel = (option) => (
    <OptionRow>
      <OptionName>{option.label}</OptionName>
      <OptionMeta>
        {option.categoryName || "—"}
        {option.suggestionCount > 0 ? ` · ${option.suggestionCount} suggestion(s)` : ""}
      </OptionMeta>
    </OptionRow>
  );

  return (
    <PickerWrap>
      <PickerTitle>Choisissez un produit</PickerTitle>
      <PickerSub>
        Seuls les produits avec ingrédients à choix ou des suggestions existantes sont listés.
      </PickerSub>
      <Select
        options={options}
        value={null}
        placeholder={isLoadingProducts ? "Chargement des produits…" : "Rechercher un produit…"}
        isLoading={isLoadingProducts}
        isDisabled={!establishment || isLoadingProducts}
        formatOptionLabel={formatOptionLabel}
        noOptionsMessage={() => "Aucun produit éligible"}
        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
        menuPosition="fixed"
        menuPlacement="auto"
        maxMenuHeight={320}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 99999 }),
        }}
        onMenuOpen={() => {
          setTimeout(() => {
            window.dispatchEvent(new Event("resize"));
          }, 50);
        }}
        onChange={(option) => option && onSelect(option.value)}
      />
    </PickerWrap>
  );
};

const PickerWrap = styled.div`
  max-width: 560px;
  margin: 0 auto;
  padding: 32px 0;
`;
const PickerTitle = styled.h2`
  font-size: 19px;
  margin: 0 0 6px;
  font-weight: 800;
  color: #1d1d1b;
  text-align: center;
`;
const PickerSub = styled.p`
  margin: 0 0 18px;
  color: #6b6b68;
  font-size: 13px;
  text-align: center;
`;
const OptionRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
const OptionName = styled.span`
  font-weight: 700;
  font-size: 14px;
  color: #1d1d1b;
`;
const OptionMeta = styled.span`
  font-size: 12px;
  color: #6b6b68;
`;

export default ProductPicker;
